/* eslint import/no-extraneous-dependencies: off */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import history from '@history';
import _ from '@lodash';
import { setUser as setSentryUser } from '@sentry/react';
import settingsConfig from 'app/fuse-configs/settingsConfig';
import jwtService from 'app/auth/services/jwtService';
import { setDefaultSettings, setInitialSettings } from './fuse/settingsSlice';
import { showMessage } from './fuse/messageSlice';
import { changeLanguage, loadCustomTranslations } from './i18nSlice';

export const setUser = createAsyncThunk('user/setUser', async (user: any, { dispatch, getState }) => {
	const {
		app: { translations, ...app }
	} = user;

	/*
		You can redirect the logged-in user to a specific route depending on his roles
	*/
	// if (loginRedirectURl) {
	// 	settingsConfig.loginRedirectUrl = loginRedirectURl;
	// } else {
	// 	settingsConfig.loginRedirectUrl = `users/details/${uid}`;
	// }

	/*
    	Set user language
	*/
	dispatch(changeLanguage(user.data.user_language || 'it'));

	/*
		Set app translations
	*/
	dispatch(loadCustomTranslations(translations));

	/*
    	Set user layout and theme
	*/
	dispatch(
		setDefaultSettings({
			layout: { style: user.data.user_layout },
			theme: {
				footer: user.data.user_theme,
				main: user.data.user_theme,
				navbar: user.data.user_theme,
				toolbar: user.data.user_theme
			}
		})
	);

	/*
    	Set Sentry user data
	*/
	setSentryUser({
		id: user.data.user_uid,
		username: user.data.user_title,
		email: user.data.user_mail,
		segment: user.data.user_role
	});

	return { ...user, app };
});

export const updateUserSettings = createAsyncThunk(
	'user/updateSettings',
	async (settings: any, { dispatch, getState }) => {
		const { user }: any = getState();
		const newUser = _.merge({}, user, { data: { settings } });

		// dispatch(updateUserData(newUser));

		return newUser;
	}
);

export const updateAppSettings = settings => async (dispatch, getState) => {
	const oldUser = getState().user;
	// const newUser = _.merge({}, oldUser, { data: { settings } });
	const newUser = _.merge({}, oldUser, {
		app: { sysSettings: settings }
	});

	// dispatch(updateUserData(newUser));

	return newUser;
};

export const updateUserShortcuts = createAsyncThunk(
	'user/updateShortucts',
	async (shortcuts: any[], { dispatch, getState }) => {
		const { user }: any = getState();
		const newUser = {
			...user,
			data: {
				...user.data,
				shortcuts
			}
		};

		// dispatch(updateUserData(newUser));

		return newUser;
	}
);

export const logoutUser = () => async (dispatch, getState) => {
	const { user } = getState();

	if (!user.roles || user.roles.length === 0) {
		// is guest
		return null;
	}

	history.push({ pathname: '/login' });

	jwtService.logout();

	dispatch(setInitialSettings());

	setSentryUser(null);

	return dispatch(userLoggedOut());
};

// export const updateUserData = user => async (dispatch, getState) => {
// 	if (!user.role || user.role.length === 0) {
// 		// is guest
// 		return;
// 	}

// 	jwtService
// 		.updateUserData(user)
// 		.then(() => {
// 			dispatch(showMessage({ message: 'User data saved with api' }));
// 		})
// 		.catch(error => {
// 			dispatch(showMessage({ message: error.message }));
// 		});
// };

const initialState = {
	role: [], // guest
	data: {
		displayName: 'John Doe',
		photoURL: 'assets/images/avatars/brian-hughes.jpg',
		email: 'johndoe@withinpixels.com',
		shortcuts: ['apps.calendar', 'apps.mailbox', 'apps.contacts', 'apps.tasks']
	}
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		userLoggedOut: () => initialState
	},
	extraReducers: builder => {
		builder.addCase(updateUserSettings.fulfilled, (state, action) => action.payload);
		builder.addCase(updateUserShortcuts.fulfilled, (state, action) => action.payload);
		builder.addCase(setUser.fulfilled, (state, action) => action.payload);
	}
});

export const { userLoggedOut } = userSlice.actions;

export const selectUser = ({ user }) => user;

export const selectUserShortcuts = ({ user }) => user.data.shortcuts;

export default userSlice.reducer;
